import {Environment, getWebsocketScheme} from "src/environments";
import {theme} from "./theme";

export const environment: Environment = {
  ...theme, ...{

    backend: "OpenEMS Edge",
    // url: getWebsocketScheme() + "://" + location.hostname + ":8085",
    url: getWebsocketScheme() + "://192.168.0.174" + ":8085",

    production: false,
    debugMode: true,
  },
  keycloak: {
    url: "",
    clientId: "",
    realm: "",
  },
  portal: {
    apiUrl: "",
  },
};
